export default "__VITE_ASSET__DAw9Ykgc__"